import React, { useState } from "react";
import { Save, Rocket, ArrowLeft } from "lucide-react";

export default function WatchlistCreate({ existingNames, onSave, onBack }) {
  const [name, setName] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmed = name.trim();
    if (!trimmed) {
      setError("Please enter a name for your watchlist.");
      return;
    }
    if (existingNames.some((n) => n.toLowerCase() === trimmed.toLowerCase())) {
      setError("You already have a watchlist with this name.");
      return;
    }
    onSave(trimmed);
  };

  return (
    <main className="page-bg">
      <div className="create-wl-wrap">
        <div className="card create-wl-card">
          <h1 className="create-wl-title">Create new watchlist</h1>

          <form onSubmit={handleSubmit} noValidate>
            <label htmlFor="wl-name" className="create-wl-label">Name</label>
            <input
              id="wl-name"
              type="text"
              className={`form-control create-wl-input ${error ? "is-invalid" : ""}`}
              value={name}
              maxLength={40}
              autoFocus
              onChange={(e) => {
                setName(e.target.value);
                setError("");
              }}
            />
            {error && <div className="invalid-feedback d-block">{error}</div>}

            <button type="submit" className="btn btn-purple create-wl-save">
              <Save size={16} /> SAVE
            </button>
          </form>

          <div className="create-wl-info">
            <div className="create-wl-illustration">
              <Rocket size={72} />
            </div>
            <p>
              Create separate watchlists to organize companies by idea, theme or
              strategy, such as long-term holds or stocks you are still researching.
            </p>
            <p className="mb-0">
              Keep each list focused so the companies you care about most stay easy to find.
            </p>
          </div>
        </div>

        <div className="go-back-row">
          <a
            href="#"
            className="go-back"
            onClick={(e) => {
              e.preventDefault();
              onBack();
            }}
          >
            <ArrowLeft size={16} /> Go Back
          </a>
        </div>
      </div>
    </main>
  );
}